export default __webpack_public_path__ + "static/media/design--dotted-raster--ffffff-clean--0.325f91d3.png";